import type { EligibilityCheckResponse } from '@features/patient-coverages';

import type { BlockReadiness } from '../types/readiness';

export type EligibilityCheckState = NonNullable<
  EligibilityCheckResponse['eligibility_check_state']
>;

export const DEFAULT_ELIGIBILITY_CHECK_STATE: EligibilityCheckState = 'not_applicable';

type EligibilityCheckStateSource = Pick<
  Partial<EligibilityCheckResponse>,
  'eligibility_check_state'
>;

export function getEligibilityCheckState(
  data: EligibilityCheckStateSource | undefined,
): EligibilityCheckState {
  return data?.eligibility_check_state ?? DEFAULT_ELIGIBILITY_CHECK_STATE;
}

export function isEligibilityCheckDue(data: EligibilityCheckStateSource | undefined): boolean {
  return getEligibilityCheckState(data) === 'due';
}

/**
 * The server's reason a check is due when no check speaks for the plan, such
 * as "Plan changed" after its member ID or payer changed (GDN-4267). Null when
 * the check is due for another reason (never run, or a stale verdict) or is
 * not due.
 */
export function dueCheckReason(
  state: EligibilityCheckState,
  readiness: BlockReadiness | null,
  readinessLabel: string | null | undefined,
): string | null {
  if (state !== 'due' || readiness !== null) return null;
  return readinessLabel?.trim() || null;
}
